import axios from "axios";

export const ORDERS_URL = `${process.env.REACT_APP_API_URL}/orders`;
export const LOGS_URL = `${process.env.REACT_APP_API_URL}/logs`;

// CREATE

export function createOrder(order) {
  return axios.post(`${ORDERS_URL}/create`, order);
}

export function getOrderById(orderId) {
  return axios.get(`${ORDERS_URL}/${orderId}`);
}

export function getOrderLogs(orderId) {
  return axios.get(LOGS_URL, {
    params: {
      model: "Order",
      recordId: orderId,
    },
  });
}

export function getOpenOrder() {
  return axios.get(`${ORDERS_URL}/open`);
}

export function finalizeOrder(orderToFinalize) {
  return axios.post(`${ORDERS_URL}/finalize`, orderToFinalize);
}

export function findOrders(queryParams) {
  return axios.get(ORDERS_URL, {
    params: {
      pageSize: queryParams.pageSize,
      pageNumber: queryParams.pageNumber,
      ...queryParams.filter,
    },
  });
}

export function deleteOrder() {
  return axios.delete(`${ORDERS_URL}`);
}

export function approveOrder(orderId){
  
  return axios.post(`${ORDERS_URL}/approve`, {
    orderId: orderId
  });
}
